import Axios from "../utils/axiosInstance";

// API: Get products by country name
export const getProductsByCountry = async (countryName) => {
  try {
    let token = sessionStorage.getItem("token");
    const response = await Axios.get(`/products/country/${countryName}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const rawData = response.data?.data || response.data;
    return Array.isArray(rawData) ? rawData : [];
  } catch (error) {
    console.error("Error fetching products by country:", error);
    throw error;
  }
};

// API: Delete quote by ID
export const deleteQuote = async (quoteId) => {
  try {
    let token = sessionStorage.getItem("token");
    const response = await Axios.delete(`/confugrator/deleteQuote/${quoteId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting quote:", error);
    throw error;
  }
};

// API: Upload Component Excel file
export const uploadComponentsExcel = async (file) => {
  try {
    const token = sessionStorage.getItem("token");
    const formData = new FormData();
    formData.append("file", file);
    const response = await Axios.post("/components/upload", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Upload Component Excel Error:", error);
    throw error;
  }
};

// API: Get all uploaded master components
export const getUploadedComponents = async () => {
  try {
    const token = sessionStorage.getItem("token");
    const response = await Axios.get("components/getallComponents", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Fetch Components Error:", error);
    throw error;
  }
};

// API: Get Product Configuration based on model, duType, type, flowRate
export const getConfiguration = async ({ model, duType, type, flowRate }) => {
  try {
    let token = sessionStorage.getItem("token");
    let queryParams = [];
    if (model) queryParams.push(`model=${model}`);
    if (duType) queryParams.push(`duType=${duType}`);
    if (type) queryParams.push(`type=${type.toUpperCase()}`);
    if (flowRate) queryParams.push(`flowRate=${flowRate}`);
    const queryString = queryParams.join("&");
    const response = await Axios.get(`/products/getConfiguration?${queryString}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data?.data || response.data;
  } catch (error) {
    console.error("Error fetching configuration:", error);
    throw error;
  }
};

// API: Get components against DU configuration
export const getComponentAgainstDuConfiguration = async (payload) => {
  try {
    let token = sessionStorage.getItem("token");
    const response = await Axios.post(
      `/components/getComponentAgainsduConfiguration`,
      payload,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data?.data || response.data;
  } catch (error) {
    console.error("Error fetching components against DU configuration:", error);
    throw error;
  }
};

// API: Get all products
export const getAllProducts = async () => {
  try {
    let token = sessionStorage.getItem("token");
    const response = await Axios.get("/products/getProducts", {
      headers: { Authorization: `Bearer ${token}` },
    });
    const rawData = response.data?.data || response.data;
    return Array.isArray(rawData) ? rawData : [];
  } catch (error) {
    console.error("Error fetching all products:", error);
    throw error;
  }
};

// API: Create new product
export const createProduct = async (productData) => {
  try {
    let token = sessionStorage.getItem("token");
    const response = await Axios.post("/products/createProduct", productData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating product:", error);
    throw error;
  }
};

// API: Download Component list as PDF
export const getComponentPdfDownload = async (payload) => {
  try {
    let token = sessionStorage.getItem("token");
    const response = await Axios.post(
      "/components/getComponentListInPDF",
      payload,
      {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    console.error("Error downloading component PDF:", error);
    throw error;
  }
};

// API: Save quote as draft
export const saveAsDraft = async (draftData) => {
  try {
    let token = sessionStorage.getItem("token");
    const response = await Axios.post("confugrator/addQuote", draftData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error saving draft:", error);
    throw error;
  }
};

// API: Get all quotes list
export const getAllQuoteList = async () => {
  try {
    let token = sessionStorage.getItem("token");
    let pkUserId = sessionStorage.getItem("pkUserId") || "";
    let role = sessionStorage.getItem("role") || "";
    const response = await Axios.get(
      `confugrator/getAllQuoteList?pkUserId=${pkUserId}&role=${role}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data?.data || response.data;
  } catch (error) {
    console.error("Error fetching quote list:", error);
    throw error;
  }
};

// API: Get BOM components against Quote ID
export const getBomComponentsByQuoteId = async (quoteId) => {
  try {
    let token = sessionStorage.getItem("token");
    const response = await Axios.get(
      `confugrator/getAllBomComponentsAgainstQuoteId?quoteId=${quoteId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data?.data || response.data;
  } catch (error) {
    console.error(`Error fetching BOM components for Quote ID ${quoteId}:`, error);
    throw error;
  }
};

// API: Update BOM component details
export const updateBomComponent = async (payload) => {
  try {
    let token = sessionStorage.getItem("token");
    let pkUserId = sessionStorage.getItem("pkUserId") || "";
    let role = sessionStorage.getItem("role") || "";
    const response = await Axios.post(
      `confugrator/updateBomComponent?pkUserId=${pkUserId}&role=${role}`,
      payload,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating BOM component:", error);
    throw error;
  }
};

// API: Get quote approval details
export const getApprovalDetails = async (quoteId) => {
  try {
    let token = sessionStorage.getItem("token");
    const response = await Axios.get(
      `confugrator/getApprovalDetails?quoteId=${quoteId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data?.data || response.data;
  } catch (error) {
    console.error(`Error fetching approval details for Quote ID ${quoteId}:`, error);
    throw error;
  }
};

// API: Submit quote for approval
export const submitForApproval = async (payload) => {
  try {
    let token = sessionStorage.getItem("token");
    const response = await Axios.post(`confugrator/submitforApproval`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error submitting quote for approval:", error);
    throw error;
  }
};

// API: Submit query/clarification on quote
export const submitQuery = async (queryPayload) => {
  try {
    let token = sessionStorage.getItem("token");
    let role = sessionStorage.getItem("role") || "";
    if (role.toUpperCase().includes("SALES")) {
      role = "Sales_person";
    }
    const response = await Axios.post(
      `confugrator/addQuery?role=${role}`,
      queryPayload,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error in submitQuery:", error);
    throw error;
  }
};

// API: Respond to quote query
export const respondToQuery = async (payload) => {
  try {
    let token = sessionStorage.getItem("token");
    let role = sessionStorage.getItem("role") || "";
    if (role.toUpperCase().includes("SALES")) {
      role = "Sales_person";
    }
    const response = await Axios.post(
      `confugrator/respondToQuery?role=${role}`,
      payload,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error responding to query:", error);
    throw error;
  }
};

// API: Get quote query discussion history
export const getQueryHistory = async (quoteId) => {
  try {
    let token = sessionStorage.getItem("token");
    const response = await Axios.get(
      `confugrator/getQueryHistory?quoteId=${quoteId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data?.data || response.data;
  } catch (error) {
    console.error("Error fetching query history:", error);
    throw error;
  }
};

// Consolidate in AllSalestoolAPI and alias as productService for full compatibility
export const AllSalestoolAPI = {
  getProductsByCountry,
  deleteQuote,
  uploadComponentsExcel,
  getUploadedComponents,
  getConfiguration,
  getComponentAgainstDuConfiguration,
  getAllProducts,
  createProduct,
  getComponentPdfDownload,
  saveAsDraft,
  getAllQuoteList,
  getBomComponentsByQuoteId,
  updateBomComponent,
  getApprovalDetails,
  submitForApproval,
  submitQuery,
  respondToQuery,
  getQueryHistory,
};

export const productService = AllSalestoolAPI;
export default AllSalestoolAPI;

